export const iframeLifeCycle = {
  data() {
    return {};
  },
  computed: {},
  created() {
    const iframeLifeCycleBC = new BroadcastChannel("iframeLifeCycle");
    iframeLifeCycleBC.onmessage = (event) => {
      if (event.origin !== window.location.origin) return
      console.log(self.frameElement.getAttribute('id'), event.data.id)
      if (event.data.id && event.data.id.length && event.data.id.indexOf(self.frameElement.getAttribute('id')) === -1) return
      if (event.data.type === 'created' && this.iframeLifeCycleCreated) {
        this.iframeLifeCycleCreated()
      }
      if (event.data.type === 'destroyed' && this.iframeLifeCycleDestroyed) {
        this.iframeLifeCycleDestroyed()
      }
    }
  },
  mounted() {},
  methods: {},
};